//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColumnsSelect from '@/components/ColumnsSelect'
import SearchInput from '@/components/SearchInput'
import Bienparabien from '@/api/promotores/bienparabien.api'
import RolChip from '@/views/promotor/rol/RolChip'

const labels_estados = {
  procede_ejercido: 'En proceso de cesión',
  desarrollo_empresarial: 'Autorizada'
}

export default {
  components: { ColumnsSelect, SearchInput, RolChip },
  data() {
    return {
      visible_columns: [
        'id', 'nombre', 'importe', 'autorizado', 'plazo', 'rol_nombre', 'promotor_nombre', 'estado', 'created_at', 'updated_at'
      ],
      columns: [
        { name: "id", label: "ID", field: "id", style: "width: 10px", sortable: true },
        {
          name: "nombre",
          label: "Nombre",
          field: "nombre",
          align: "left",
          classes: "bg-grey-2 ellipsis",
          style: "width: 350px",
          headerClasses: "bg-primary text-white",
        },
        {
          name: "importe",
          label: "Monto solicitado",
          field: "importe_solicitado",
          sortable: true,
          format: this.currency,
        },
        {
          name: "autorizado",
          label: "Monto autorizado",
          field: "ejercido.monto_autorizado_comite",
          sortable: true,
          format: this.currency,
        },
        { name: "plazo", label: "Plazo", field: "plazo", sortable: true, format: this.formatPlazo },
        { name: "email", label: "Email", field: "email" },
        { name: "telefono", label: "Télefono", field: "telefono" },
        { name: "rol_nombre", label: "Grupo", field: "rol_nombre", sortable: true },
        { name: "promotor_nombre", label: "Promotor", field: "promotor_nombre", sortable: true, },
        { name: "estado", label: "Estado", format: this.formatArea },
        { name: "created_at", label: "Creación", field: "created_at", sortable: true, },
        { name: "updated_at", label: "Actualizado", field: "updated_at", sortable: true, },
      ],
      solicitudes: [],
      loading: false,
      filter: null,
			urlServicios: process.env.VUE_APP_SERVICIOS_WEB,
			showBanner: true,
    }
  },

  mounted() {
    this.loadSolicitudes()
  },

  methods: {

    async loadSolicitudes() {
      try {
        this.loading = true
        this.solicitudes = await Bienparabien.all()
      } finally {
        this.loading = false
      }
    },
    formatArea(area, solicitud) {
      const areas = ["ejercido", "comite", "entrevistas", "citas", "opinion", "callback"]

      for (let area of areas) {
        if (solicitud[`procede_${area}`] === 1) {
          return labels_estados.hasOwnProperty(`procede_${area}`) ? labels_estados[`procede_${area}`] : `Procede ${area}`
        }

        if (solicitud[`procede_${area}`] === 0) {
          return `No procede ${area}`
        }

        if (solicitud[`procede_${area}`] === null && solicitud[`created_${area}`] !== null) {
          return `Pendiente ${area}`
        }

        if (solicitud[`procede_${area}`] === 2) {
          return `Prospecto ${area}`
        }
      }

      return "Pendiente callback"
    },
    formatPlazo(plazo) {
      return this.pluralize(plazo, ["año", "años"])
    },
  }
}
